import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  TextField,
  TableFooter,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MUIDataTable from 'mui-datatables';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { useNavigate, Link } from 'react-router-dom';
import Scrollbar from 'src/components/scrollbar';
import Iconify from '../../../iconify';
import { AuthContext } from 'src/context/AuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { CalculateBillableCosts } from 'src/components/customecomponent/CalculateBillableCosts';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { toast } from 'react-hot-toast';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const { PRIVATE_ROUTE } = API_ROUTES;

export default function ManagersideTasklist() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const { state } = useContext(AuthContext);
  const [selectedstartDate, setselectstartDate] = useState(null);
  const [selectendDate, setselectendDate] = useState(null);
  const [isValidDate, setIsValidDate] = useState(false);
  const [totalInvoiceCost, setTotalInvoiceCost] = useState(0);
  const [totalBillableCost, setTotalBillableCost] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [pendingDuplicate, setPendingDuplicate] = useState(null);
  const [manageId, setManageId] = useState('All_Manager');
  const [managerList, setManagerList] = useState([]);


  const navigate = useNavigate();

  const getManagerData = async () => {
    try {
      const { data } = await authAxios.get(PRIVATE_ROUTE.GET_MANAGER);
      setManagerList(data?.data || []);
    } catch (error) {
      console.error('Error fetching managers:', error);
    }
  };

  useEffect(() => {
    getManagerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditRedirect = (e, id) => {
    setOpen(null);
    setSelectedRow(null);
    navigate(`/manager/task/update/${id}`);
  };
  const handleRowDelete = async (e, id) => {
    await authAxios.post(`${PRIVATE_ROUTE?.DELETE_TASK}${id}`);
    getTaskdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  };

  const handlejobcreateform = () => {
    navigate('/manager/task/create');
  };

  const estimatedBillableCostData = async (query = {}) => {
    setTotalInvoiceCost(0);
    setTotalBillableCost(0);

    const start_date = query.selectedstartDate ?? selectedstartDate ?? '';
    const end_date = query.selectendDate ?? selectendDate ?? '';
    const selectedManagerId = query.manageId ?? manageId;

    const sort_params = `&startDate=${start_date}&endDate=${end_date}`;

    try {
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_TASK_TOTAL_ESTIMATED_HOURS}?is_complete=1&user_id=${selectedManagerId}${sort_params}`
      );

      setTotalBillableCost(parseFloat(data.totalBillableCost));
      setTotalInvoiceCost(parseFloat(data.totalEstimatedCost));
    } catch (error) {
      console.error('Error fetching employee data:', error);
    }
  };

  useEffect(() => {
    if (state) {
      estimatedBillableCostData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const getTaskdata = (query) => {
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;

    const selectedManagerId = query.manageId || manageId;

    const start_date =
      query.startDate !== undefined
        ? query.startDate
        : selectedstartDate !== null
          ? selectedstartDate
          : '';

    const end_date =
      query.endDate !== undefined
        ? query.endDate
        : selectendDate !== null
          ? selectendDate
          : '';
    let search_query = query.searchQuery ? encodeURIComponent(query.searchQuery) : '';
    if (typeof query !== 'string') {
      sort_params = `&startDate=${start_date}&endDate=${end_date}&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}&startDate=${start_date}&endDate=${end_date}`;
    }
    let isMounted = true;
    const getTasks = async () => {

      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_TASK}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}&is_complete=1&user_id=${selectedManagerId}`
      );
      if (isMounted) {
        setTasks(
          data?.data?.map((item) => {
            const project_managers_name = item.project_managers.map(
              (pmdetails) => pmdetails.first_name + ' ' + pmdetails.last_name
            );
            const totalOfDwrCost = CalculateBillableCosts(item);
            const totalBilebleSum = totalOfDwrCost.reduce((acc, curr) => acc + curr.totalCost, 0);
            return {
              _id: item._id,
              name: item.name,
              task_number: (
                <Link to={`/manager/task/view/${item._id}`}>
                  <b>{item.number_str}</b>
                </Link>
              ),
              job_number: (
                <Link to={`/manager/job/view/${item.job_id._id}`}>
                  <b>{item.job_id.number_str}</b>
                </Link>
              ),
              client_id: item.client_id._id,
              client_number: (
                <Link to={`/manager/client/view/${item.client_id._id}`}>
                  <b>{item?.client_id?.company_name}</b>
                </Link>
              ),
              quote_number: (
                <Link to={`/manager/quote/view/${item?.quote_id?._id}`}>
                  <b>{item?.quote_id?.number_str}</b>
                </Link>
              ),
              task_scope: item?.task_scope_id?.name,
              is_completed: item.is_completed,
              ratesheet: item.ratesheet_id.name,
              manager: project_managers_name.join(', '),
              invoice_number: item?.invoice_id ? item?.invoice_id.number_str : '-',
              invoiced_amount: item?.invoice_id?.sub_total
                ? item?.invoice_id?.sub_total
                : item?.invoice_amount
                  ? item?.invoice_amount
                  : `-`,
              billable_cost: totalBilebleSum,
              doc_number: item.is_invoice_generated ? item?.invoice_id?.doc_number : `-`,
              invoice_status: item?.invoice_id ? (item?.invoice_id?.is_paid === 1 ? 'Paid' : 'Unpaid') : '-',
              is_invoice_generated: item?.is_invoice_generated,
              job_number_str: item?.job_id?.number_str,
            };
          })
        );
        setCount(data.total);
        setLoading(false);
      }
    };
    getTasks().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };

  function handleDateSort() {
    if (selectendDate !== null && selectedstartDate !== null) {
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
      estimatedBillableCostData({ selectendDate: selectendDate, selectedstartDate: selectedstartDate });
      setLoading(true);
    }
  }

  function handleClearDateSort() {
    setselectendDate(null);
    setselectstartDate(null);
    setManageId('All_Manager');
    setPage(0);
    setLoading(true);

    getTaskdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: 0,
      manageId: 'All_Manager',
      startDate: '',
      endDate: '',
    });

    estimatedBillableCostData({
      selectedstartDate: '',
      selectendDate: '',
      manageId: 'All_Manager',
    });
  }


  useEffect(() => {
    if (rowsPerPage * page < count) {
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    } else {
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
    setLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  const columns = [
    {
      name: '_id',
      label: 'Id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'task_number',
      label: 'Task Number',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: `job_number`,
      label: 'Job Number',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'client_number',
      label: 'Client',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'ratesheet',
      label: 'RateSheet',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'billable_cost',
      label: 'Billable Cost',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,
      },
    },
    {
      name: 'invoiced_amount',
      label: 'Invoiced Amount',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,
      },
    },
    {
      name: 'invoice_number',
      label: 'Invoice Number',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,
      },
    },
    {
      name: 'doc_number',
      label: 'QB Invioce #',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'invoice_status',
      label: 'Invoice Status',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,
      },
    },
    {
      name: 'task_scope',
      label: 'Task Scope',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: "is_invoice_generated",
      label: "Invoice Generated",
      options: {
        display: false, // you can hide it but still access it
      }
    },
    {
      name: '',
      lable: 'Action',
      options: {
        filter: true,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const { rowIndex } = tableMeta;
          const rowData = tasks[rowIndex];
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              {!rowData.is_invoice_generated && (
                <Tooltip title="Generate Invoice" arrow>
                  <ReceiptOutlinedIcon
                    onClick={() => handleGenerateInvoice(rowData._id, rowData.client_id)}
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
              )}
              <Tooltip title="Duplicate" arrow>
                <ContentCopyIcon // <- Material UI copy/duplicate icon
                  style={{ cursor: 'pointer' }}
                  // onClick={(e) => handleDuplicate(e, tableMeta.rowData[0])}
                  onClick={(e) => handleDuplicate(e, rowData._id, rowData.client_id, rowData.job_number_str)}
                />
              </Tooltip>
              <EditIcon
                color={tableMeta.rowData[1] ? 'disabled' : 'inherit'}
                onClick={tableMeta.rowData[1] ? undefined : (e) => handleEditRedirect(e, tableMeta.rowData[0])}
              />
              <DeleteIcon
                color={tableMeta.rowData[1] ? 'disabled' : 'inherit'}
                onClick={tableMeta.rowData[1] ? undefined : (e) => handleRowDelete(e, tableMeta.rowData[0])}
              />
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    filter: false,
    fixedHeader: true,
    searchOpen: true,
    count: count,
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];

          item.data.forEach((el) => {
            if (typeof el !== 'object') {
              result.push(el);
            }

            if (typeof el === 'object') {
              if (el.props?.to) {
                result.push(el.props.children.props.children);
              }

              if (Array.isArray(el.props?.children)) {
                const childrenArray = el.props.children;

                const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
                result.push(combinedString);

              }
            }
          });

          return result;
        }

        return null;
      });
      const result = formattedData.map((data, index) => ({
        index: index,
        data: data,
      }));
      const footerData = ['', '', '', '', 'Total Task Cost', `${totalBillableCost}`, `${totalInvoiceCost}`, ''];
      return `${buildHead(columns)}${buildBody(result)}\n${footerData.join(',')}\n`;

    },
    setRowProps: (row, dataIndex, rowIndex) => ({
      style: {
        backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)' : 'white',
      },
    }),
    setTableProps: () => ({
      padding: 'default',
      border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
      size: 'small',
    }),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },

    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery !== null && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getTaskdata({ sortField, sortOrder, searchQuery });
        } else {
          getTaskdata({ searchQuery });
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getTaskdata({ sortField, sortOrder });
        } else {
          getTaskdata('');
        }
        setLoading(true);
      }
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,

    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;

      const sortField = name;
      const sortOrder = direction;
      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable({ sortField, sortOrder });
        if (searchEnable) {
          getTaskdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getTaskdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
      setPage(tableState.page);
      if (action === 'changePage') {
        if (searchEnable) {
          getTaskdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getTaskdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
    },
    customTableBodyFooterRender: (opts, key) => (
      <>
        <TableFooter key={key}>
          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, border: '1px solid #808080' }}>
            {opts.columns.map((col, index) => {
              if (col.name === 'task_number') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                    key={index}
                  >
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'job_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'client_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'invoice_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'quote_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'manager') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'ratesheet') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                      textAlign: 'end',
                    }}
                    key={index}
                  >
                    Total:
                  </TableCell>
                );
              }
              if (col.name === 'billable_cost') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                    key={index}
                  >
                    {totalBillableCost.toFixed(2)}
                  </TableCell>
                );
              }
              if (col.name === 'invoiced_amount') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                    key={index}
                  >
                    {totalInvoiceCost.toFixed(2)}
                  </TableCell>
                );
              }
              if (col.name === 'status') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'Action') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'invoice_status') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'doc_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === '') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
            })}
          </TableRow>
        </TableFooter>
      </>
    ),
  };

  const handleGenerateInvoice = (taskId, clientId) => {
    navigate(`/invoice/create?taskId=${taskId}&clientId=${clientId}`);
  };

  // const handleDuplicate = async (e, taskId) => {
  //   e.preventDefault();
  //   if (!window.confirm('Are you sure you want to duplicate this task?')) return;

  //   try {
  //     setLoading(true);
  //     const { data } = await authAxios.post(
  //       `${PRIVATE_ROUTE.DUPLICATE_TASK}${taskId}`
  //     );

  //     if (data?.statusCode === 200) {
  //       toast.success('Task duplicated successfully');

  //       const newTaskId = data?.task?._id || data?.taskId;

  //       if (newTaskId) {
  //         navigate(`/task/update/${newTaskId}`);
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error duplicating task:', error);
  //     toast.error('Failed to duplicate task');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDuplicate = async (e, taskId, clientId, jobNumber) => {
    e.preventDefault();

    try {
      setLoading(true);

      const warnings = await validateBeforeDuplicate({
        clientId,
        jobNumber,
      });

      if (warnings.length > 0) {
        setAlertMessage(warnings.join('\n'));

        // 🔒 Save pending action
        setPendingDuplicate({ taskId });

        setAlertOpen(true);
        return; // ⛔ STOP here, wait for dialog action
      }

      // No warnings → duplicate directly
      await duplicateTask(taskId);
    } catch (error) {
      console.error('Error duplicating task:', error);
      toast.error('Failed to duplicate task');
    } finally {
      setLoading(false);
    }
  };

  const duplicateTask = async (taskId) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.DUPLICATE_TASK}${taskId}`);

      if (data?.statusCode === 200) {
        toast.success('Task duplicated successfully');

        const newTaskId = data?.task?._id || data?.taskId;
        if (newTaskId) {
          const managerUrl = `/manager/task/update/${newTaskId}`;
          navigate(managerUrl);
        }
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to duplicate task');
    }
  };

  const validateBeforeDuplicate = async ({ clientId, jobNumber }) => {
    let messages = [];

    if (clientId) {
      const clientRes = await authAxios.get(`${PRIVATE_ROUTE.GET_CLIENT_BY_ID}/${clientId}`);

      const client = clientRes?.data?.data[0];
      const clientTasks = client?.tasksdata || [];
      const clientInvoices = await fetchInvoicesforclient(clientId);

      if (clientTasks.length > 0) {
        messages.push(`${clientTasks.length} active task exist for this client.`);
      }

      if (clientInvoices.length > 0) {
        messages.push(`${clientInvoices.length} unpaid invoice exist for this client.`);
      }
    }

    if (jobNumber) {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_JOB_SEARCH}?search=${jobNumber}`);

      const job = data?.data?.[0];
      const jobTasks = job?.task || [];

      const taskIds = jobTasks.map((t) => t._id);
      const invoices = await fetchInvoices(taskIds);

      const activeTasks = jobTasks.filter((task) => task.is_completed === 0).length;

      const unpaidInvoices = invoices.filter((inv) => inv.is_paid === 0).length;

      if (activeTasks > 0) {
        messages.push(`${activeTasks} active task already exist for this job.`);
      }

      if (unpaidInvoices > 0) {
        messages.push(`${unpaidInvoices} unpaid invoice exist for this job.`);
      }
    }

    return messages;
  };

  const fetchInvoicesforclient = async (clientId) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.GET_INVOICES_BY_CLIENT}`, { client_id: clientId });
      return data.data || [];
    } catch (err) {
      console.error('Failed to fetch invoices:', err);
      return [];
    }
  };

  const fetchInvoices = async (taskIds) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.GET_INVOICES_BY_TASKS}`, { taskIds });
      return data.data || [];
    } catch (err) {
      console.error('Failed to fetch invoices:', err);
      return [];
    }
  };

  return (
    <>
      <Dialog open={alertOpen} onClose={() => setAlertOpen(false)}>
        <DialogTitle>⚠️ Confirmation Required</DialogTitle>

        <DialogContent>
          {alertMessage.split('\n').map((line, i) => (
            <p key={i} style={{ margin: '6px 0' }}>
              {line}
            </p>
          ))}
          <p style={{ marginTop: '12px', fontWeight: 500 }}>Do you still want to duplicate this task?</p>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setAlertOpen(false);
              setPendingDuplicate(null);
            }}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={() => {
              if (pendingDuplicate?.taskId) {
                duplicateTask(pendingDuplicate.taskId);
              }
              setAlertOpen(false);
              setPendingDuplicate(null);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Grid sx={{ p: 4, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Complete Task
          </Typography>
          <Button variant="contained" onClick={handlejobcreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Task
          </Button>
        </Stack>
        <Grid container xs={8} spacing={2} sx={{ py: 2, alignItems: 'center' }}>
          {/* Project Manager */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="manager-filter-label">Select Manager</InputLabel>

              <Select
                labelId="manager-filter-label"
                value={manageId}
                label="Select Manager"
                onChange={(e) => {
                  const selectedManager = e.target.value;

                  setManageId(selectedManager);
                  setPage(0);
                  setLoading(true);

                  getTaskdata({
                    sortField: sortEnable.sortField,
                    sortOrder: sortEnable.sortOrder,
                    searchQuery: searchEnable,
                    page_no: 0,
                    manageId: selectedManager,
                  });

                  estimatedBillableCostData({
                    selectedstartDate,
                    selectendDate,
                    manageId: selectedManager,
                  });
                }}
              >
                <MenuItem value="All_Manager">All</MenuItem>

                {managerList
                  .filter((manager) => manager._id === state?.user?._id)
                  .map((manager) => (
                    <MenuItem key={manager._id} value={manager._id}>
                      {manager.first_name} {manager.last_name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Start Date */}
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={selectedstartDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectstartDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
              />
            </LocalizationProvider>
          </Grid>

          {/* End Date */}
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={selectendDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectendDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
                minDate={selectedstartDate}
                onError={(newError) => setIsValidDate(newError)}
              />
            </LocalizationProvider>
          </Grid>

          {/* Submit */}
          <Grid item xs={12} md="auto">
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={handleDateSort}
              disabled={
                selectendDate === null ||
                selectedstartDate === null ||
                isValidDate
              }
            >
              Submit
            </Button>
          </Grid>

          {/* Reset */}
          <Grid item xs={12} md="auto">
            <Button
              size="large"
              type="button"
              variant="outlined"
              onClick={handleClearDateSort}
              disabled={
                selectendDate === null &&
                selectedstartDate === null &&
                manageId === 'All_Manager'
              }
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        <Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <MUIDataTable options={options} columns={columns} data={tasks} />

                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}

                {tasks.length === 0 && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </>
  );
}
